import * as React from "react";

import { LoginModal } from "@soft/containers/Login";

export const HeaderModals = (): React.ReactElement => (
  <React.Fragment>
    <LoginModal />
  </React.Fragment>
);
